export default __webpack_public_path__ + "static/media/baseball-img.7479243e.png";